import React, {useEffect, useState} from 'react';
import {useLastViewed} from "./lib/LastViewProvider";
import {Link} from "react-router-dom";
import Divider from "@mui/material/Divider";
import MDBox from "./components/MDBox";

function LastViewedMenu({setQuickSearchOpen}) {
  const {lastViewed} = useLastViewed();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(true);
  }, [])

  return (
    <>
      {ready && lastViewed?.length > 0 &&
        <MDBox>
          <Divider/>
          <h5>
            Last Viewed Customers
          </h5>
          <ul className={'list-group'}>
            {lastViewed?.map((member, index) => {
              return (
                <li
                  className={'list-group-item'}
                  key={index}>
                  <Link to={'/client/' + member.guid}
                        className={'link'}
                        onClick={(e) => {
                          setQuickSearchOpen(false);
                        }}>{member.name}</Link>
                </li>
              );
            })}
          </ul>
        </MDBox>
      }
    </>
  );
}

export default LastViewedMenu;
